import { useState } from 'react'

import { IconKey } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import { RequestAccessModal } from '~/portal/components/ConsumerRequestAccessModal'
import { LandingProduct } from '~/portal/types/product.ts'

export interface RequestAccessButtonProps {
  accentColor?: string;
  isPending: boolean;
  product: LandingProduct;
  userFullName?: string;
}

export const RequestAccessButton = ({
  accentColor,
  isPending = false,
  product,
  userFullName,
}: RequestAccessButtonProps) => {
  const { t } = useTranslation()

  const [modalOpen, setModalOpen] = useState(false)

  const handleClick = () => {
    setModalOpen(true)
  }

  return (
    <>
      <button
        aria-label={t('portal.landingPage.productTile.requestAccess.button.ariaLabel')}
        disabled={isPending}
        onClick={handleClick}
        className={clsx(
          'h-8 w-8 border-1.5 flex items-center bg-transparent rounded pointer-events-auto font-semibold justify-center px-2 gap-2',
          'text-(--sp-color-text) disabled:text-(--sp-color-text-subtle) disabled:bg-(--sp-color-surface-sunken) disabled:border-(--sp-color-border)',
          !isPending && 'border-(--sp-color-accent) dark:border-(--sp-color-accent) hover:bg-(--sp-color-surface-inverse) hover:border-(--sp-color-surface-inverse) hover:text-(--sp-color-text-inverse) dark:hover:text-(--sp-color-text-inverse)'
        )}
        style={{ fontSize: '10px', lineHeight: '11px' }}
      >
        <IconKey width={16} height={16} />
      </button>
      <RequestAccessModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        product={product}
        userFullName={userFullName || ''}
        accentColor={accentColor}
      />
    </>
  )
}